/* Base Layout
Author: Maxwell Levene @maxlevene920- Ellmarr
Date: 04/30/2025
Description: Main bike bus management page. Handles bike bus creation, viewing,
and management including passenger lists and cancellation functionality.
*/

import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Bus, Plus } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

import { BikeBusForm } from "./components/BikeBusForm";
import { BikeBusTable } from "./components/BikeBusTable";

const BikeBusPage = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [resetTableToFirstPage, setResetTableToFirstPage] = useState(false);
  const queryClient = useQueryClient();

  const handleCreateSuccess = () => {
    // Invalidate and refetch bike buses query to show the new bike bus
    queryClient.invalidateQueries({ queryKey: ["bike-buses"] });
    // Reset table to page 1 to show the new bike bus
    setResetTableToFirstPage(true);
    setIsCreating(false);
    // Reset the flag after a brief moment
    setTimeout(() => setResetTableToFirstPage(false), 100);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Bus className="h-6 w-6 text-primary" />
          <h1 className="text-3xl font-bold tracking-tight">Bike Bus Management</h1>
        </div>
        {!isCreating && (
          <Button onClick={() => setIsCreating(true)} className="gap-2">
            <Plus className="h-4 w-4" />
            Create Bike Bus
          </Button>
        )}
      </div>

      {isCreating ? (
        <Card>
          <CardHeader>
            <CardTitle>Create New Bike Bus</CardTitle>
          </CardHeader>
          <CardContent>
            <BikeBusForm
              onSuccess={handleCreateSuccess}
              onCancel={() => setIsCreating(false)}
            />
          </CardContent>
        </Card>
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>All Bike Buses</CardTitle>
          </CardHeader>
          <CardContent>
            <BikeBusTable resetToFirstPage={resetTableToFirstPage} />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default BikeBusPage; 